export default {"src":"/kaimono/_next/static/media/log-in.aa681912.svg","height":36,"width":36};